import { render, staticRenderFns } from "./GlobalSnackbar.vue?vue&type=template&id=ba2c873e&scoped=true&"
import script from "./GlobalSnackbar.vue?vue&type=script&lang=ts&"
export * from "./GlobalSnackbar.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalSnackbar.vue?vue&type=style&index=0&id=ba2c873e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2c873e",
  null
  
)

export default component.exports